import { useState, useRef, useEffect } from "react";
import { Volume2, VolumeX } from "lucide-react";

const TRACK_URL = "/audio/meditation.mp3";

export const AmbientSoundToggle = () => {
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);
  const fadeRef = useRef(null);

  const fadeTo = (target, duration) => {
    const audio = audioRef.current;
    if (!audio) return;
    clearInterval(fadeRef.current);
    const steps = 24;
    const stepTime = duration / steps;
    const startVol = audio.volume;
    const diff = target - startVol;
    let i = 0;
    fadeRef.current = setInterval(() => {
      i++;
      audio.volume = Math.min(1, Math.max(0, startVol + diff * (i / steps)));
      if (i >= steps) {
        clearInterval(fadeRef.current);
        if (target === 0) audio.pause();
      }
    }, stepTime);
  };

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (playing) {
      fadeTo(0, 900);
      setPlaying(false);
    } else {
      audio.volume = 0;
      audio.play().catch(() => {});
      fadeTo(0.55, 1200);
      setPlaying(true);
    }
  };

  useEffect(() => {
    return () => {
      clearInterval(fadeRef.current);
      if (audioRef.current) {
        audioRef.current.pause();
      }
    };
  }, []);

  return (
    <>
      <audio ref={audioRef} src={TRACK_URL} loop preload="auto" data-testid="ambient-audio-element" />
      <button
        data-testid="ambient-sound-toggle"
        onClick={toggle}
        aria-pressed={playing}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#4A6B56]/25 text-[#4A6B56] text-sm hover:bg-[#E2EAE4] transition-colors duration-300"
      >
        {playing ? <Volume2 className="w-4 h-4" /> : <VolumeX className="w-4 h-4" />}
        {playing ? "Meditation Sound On" : "Play Meditation Sound"}
      </button>
    </>
  );
};
